import { useEffect, useRef, useState, type CSSProperties } from "react";
import img14 from "../../assets/dashboard_previews/Analytics - Track User Pain Points.png";
import img1 from "../../assets/dashboard_previews/Customize Toggle Button.png";
import img2 from "../../assets/dashboard_previews/Files - Upload Custom Knowledge Source.png";
import img3 from "../../assets/dashboard_previews/Forms - Request Custom Details Any step On The Chat.png";
import img4 from "../../assets/dashboard_previews/Forms 2 - Request Custom Details Any step On The Chat.png";
import img5 from "../../assets/dashboard_previews/Identity - Set Agent Personality.png";
import img6 from "../../assets/dashboard_previews/Inbox - Analyze Chats, Pick Handoff Requests, Understand your User.png";
import img7 from "../../assets/dashboard_previews/Menu - Handle Frequently Asked Questions.png";
import img8 from "../../assets/dashboard_previews/Multilingual - Ask without borders, get answered alike.png";
import img9 from "../../assets/dashboard_previews/Overview - Overlook all your agents activity.png";
import img10 from "../../assets/dashboard_previews/Proactive Chat - Engage Users with smart suggestions.png";
import img11 from "../../assets/dashboard_previews/Publish - 1 Click Deploy Across All Platforms & CRM.png";
import img12 from "../../assets/dashboard_previews/Themes - Match your Brand Identity.png";
// import img13 from "../../assets/dashboard_previews/Visitor Persona - Auto analyze persona to learn about your users.png";
import img0 from "../../assets/dashboard_previews/upsell success.png";

import glowLeft from "../../assets/3d-rendering-liquid-shapes-icon.png";
import glowRight from "../../assets/freepik__background__88342.png";

import "./Dashboard.css";

const PREVIEW_IMAGES = [
  img0, img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img14
];
function clamp(value: number, min: number, max: number) {
  return Math.min(max, Math.max(min, value));
}

export default function Dashboard() {
  const dashboardRef = useRef<HTMLElement | null>(null);
  const dashboardShellRef = useRef<HTMLDivElement | null>(null);
  const [dashboardProgress, setDashboardProgress] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? PREVIEW_IMAGES.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === PREVIEW_IMAGES.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    const updateDashboardProgress = () => {
      const dashboardEl = dashboardRef.current;
      if (!dashboardEl) {
        return;
      }

      const rect = dashboardEl.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const shellHeight = dashboardShellRef.current?.offsetHeight ?? viewportHeight * 0.56;
      const start = viewportHeight * 0.9;
      const end = Math.max(viewportHeight - shellHeight - 56, viewportHeight * 0.28);
      const nextProgress = clamp((start - rect.top) / Math.max(start - end, 1), 0, 1);
      setDashboardProgress(nextProgress);
    };

    updateDashboardProgress();
    window.addEventListener("scroll", updateDashboardProgress, { passive: true });
    window.addEventListener("resize", updateDashboardProgress);

    return () => {
      window.removeEventListener("scroll", updateDashboardProgress);
      window.removeEventListener("resize", updateDashboardProgress);
    };
  }, []);

  const dashboardVars = {
    "--dashboard-progress": dashboardProgress.toFixed(3),
  } as CSSProperties;

  return (
    <section className="dashboard-showcase" id="dashboard" style={dashboardVars} ref={dashboardRef}>
      <div className="dashboard-sticky-wrap">
        <div className="dashboard-stage">
          <img src={glowLeft} className="dashboard-glow dashboard-glow-left" aria-hidden="true" alt="" />
          <img src={glowRight} className="dashboard-glow dashboard-glow-right" aria-hidden="true" alt="" />

          <button className="dashboard-nav-btn dashboard-nav-prev" onClick={handlePrev} aria-label="Previous image">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
          </button>

          <button className="dashboard-nav-btn dashboard-nav-next" onClick={handleNext} aria-label="Next image">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </button>

          <div className="dashboard-shell" ref={dashboardShellRef}>
            <div className="dashboard-shell-border" aria-hidden="true" />
            <div className="dashboard-shell-inner">
              <div className="dashboard-viewport">
                <img
                  key={currentIndex}
                  src={PREVIEW_IMAGES[currentIndex]}
                  alt={`SmushLabs dashboard preview ${currentIndex + 1}`}
                  className="dashboard-image dashboard-carousel-image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
